import React from 'react';
import { Modal, ModalDialog, ModalClose, Typography, Alert } from '@mui/joy';
import { stockModalSx } from './formCommon';

const StockFormModal = ({ open, onClose, title, error, onErrorClose, children }) => (
  <Modal open={open} onClose={onClose}>
    <ModalDialog sx={stockModalSx}>
      <ModalClose />
      <Typography level="h4" sx={{ mb: 2, color: 'primary.500' }}>
        {title}
      </Typography>
      {error && (
        <Alert color="danger" sx={{ mb: 2 }} onClose={onErrorClose}>
          {error}
        </Alert>
      )}
      {children}
    </ModalDialog>
  </Modal>
);

export default StockFormModal;
